import { IconButton } from 'src/components/atoms';
import styled from 'styled-components';

export const ParameterIconList = styled.div<{ column: number }>`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  grid-column-start: ${(props) => props.column};
`;

export const ParameterIconButton = styled(IconButton)`
  &:disabled {
    background-color: ${(props) =>
      props.theme.atlas.semantic.color.surface.default};
    border: none;
  }
`;
